import { useForm as useInertiaBaseForm } from "@inertiajs/react";
import type { VisitOptions } from "@inertiajs/core";

export type FormOptions = Omit<VisitOptions, "data">;

type UseInertiaFormProps = {
  url: string;
  method: "post" | "put" | "patch" | "delete";
  initialData: Record<string, any>;
};

export function useInertiaForm(props: UseInertiaFormProps & FormOptions) {
  const { url, initialData, method, ...options } = props;
  const form = useInertiaBaseForm(initialData);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    switch (method) {
      case "post":
        form.post(url, options);
        break;
      case "put":
        form.put(url, options);
        break;
      case "patch":
        form.patch(url, options);
        break;
      case "delete":
        form.delete(url, options);
        break;
    }
  };

  return { form, handleSubmit };
}
